<template>
  <v-container>
    <div class="title">Assessments</div>
    <v-row no-gutters>
      <v-col>
        <v-sheet class="assessment-sheet top-sheet left-sheet">
          <div class="assessment-name">
            <b>Personality Style</b>
            <div class="enneagram-container">
              <img width="170" :src="`assessments/enneagram/${enneagram}`" />
            </div>
          </div>
        </v-sheet>
      </v-col>
      <v-col>
        <v-sheet class="assessment-sheet top-sheet cursor-pointer">
          <div class="assessment-name">
            <b>Work Style</b>
            <div class="pro-d-container">
              <pro-d-chart
                v-if="proD"
                :stats="proD"
                style="margin-left: 0px !important;"
              ></pro-d-chart>
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <v-sheet class="assessment-sheet left-sheet cursor-pointer">
          <div class="assessment-name">
            <b>Character Strengths</b>
            <div class="via-container">
              <div v-for="el in via">
                {{ el }}
              </div>
            </div>
          </div>
        </v-sheet>
      </v-col>
      <v-col>
        <v-sheet id="js-4-mat-sheet" class="assessment-sheet cursor-pointer">
          <div class="assessment-name">
            <b>Learning Style</b>
            <div class="four-mat-container">
              <four-mat-chart :data="fourmat"></four-mat-chart>
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <div class="button-wrapper">
      <v-btn
        class="default-action-btn"
        :to="{ name: 'MemberAssessments', params: { id: userId } }"
        small
      >
        Assessments
      </v-btn>
    </div>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex"
import User from "@/lib/user"
import ProDChart from "@/components/assessments/ProDChart"
import FourMatChart from "@/components/assessments/FourMatChart"

export default {
  components: { ProDChart, FourMatChart },
  props: {
    userId: { type: Number }
  },
  computed: {
    ...mapGetters("assessments", ["getAssessmentsByUserId"]),
    enneagram() {
      let byUserId = this.getAssessmentsByUserId(this.userId)
      let assessments = byUserId ? byUserId.assessments : []
      let assessment = assessments.find(e => e.type === "Enneagram")
      return assessment && assessment.primary
        ? `type_${assessment.primary.number}.svg`
        : "no_type.svg"
    },
    proD() {
      let byUserId = this.getAssessmentsByUserId(this.userId)
      let assessments = byUserId ? byUserId.assessments : []
      let assessment = assessments.find(e => e.type === "Pro-D")
      if (assessment) {
        return assessment.areas.length > 0 ? assessment.areas[0] : undefined
      }
      return undefined
    },
    via() {
      let byUserId = this.getAssessmentsByUserId(this.userId)
      let assessments = byUserId ? byUserId.assessments : []
      let assessment = assessments.find(e => e.type === "Via")
      let areas = assessment ? assessment.areas.map(e => e.name) : []
      return areas.slice(0, 5)
    },
    fourmat() {
      let byUserId = this.getAssessmentsByUserId(this.userId)
      let assessments = byUserId ? byUserId.assessments : []
      let assessment = assessments.find(e => e.type === "4-Mat")
      let fourMat = assessment ? assessment : {}
      return fourMat
    }
  },
  data: function() {
    return {
      userType: User.getUserType()
    }
  },

  mounted() {
    this.$store.dispatch("assessments/assessmentsByUserId", {
      userId: this.userId
    })
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";

div.title {
  color: $light-yellow;
  display: flex;
  font-family: $main-font-family !important;
  font-style: italic;
  font-size: 1em !important;
  margin-top: -26px;
  padding-left: 15px;
  position: absolute;
  text-transform: uppercase;
  width: 100%;
}
div.container {
  background-color: $trophy-backgroud;
  border-radius: 25px;
  border-color: $light-grey;
  margin-top: 20px;
  position: relative;
}

div.v-sheet {
  align-items: center;
  background-color: $trophy-backgroud;
  display: flex;
  justify-content: center;
  min-height: 50px;
  height: 100%;
}
div.button-wrapper {
  padding-top: 5px;
  display: flex;
  justify-content: center;
}
div.assessment-name {
  color: $dark-grey;
  justify-content: center;
}
div.assessment-sheet {
  min-width: 150px;
  @media (max-width: 380px) {
    border-bottom: 2px solid $light-grey;
  }
}
.top-sheet {
  @media (min-width: 380px) {
    border-bottom: 2px solid $light-grey;
  }
}

.left-sheet {
  @media (min-width: 380px) {
    border-right: 2px solid $light-grey;
  }
}

.four-mat-container {
  width: 180px;
}
.pro-d-container {
  width: 180px;
  height: 200px;
}
.via-container {
  width: 180px;
  height: 185px;
  padding-top: 25px;
}
.enneagram-container {
  width: 180px;
  height: 200px;
  padding-top: 20px;
}
</style>
